// ============================================
// 设备与视口判断工具
// ============================================

/**
 * 移动端断点（与样式变量保持一致）
 */
export const MOBILE_BREAKPOINT = 768;

/**
 * 判断是否命中移动端视口
 */
export const isMobileViewport = (): boolean => {
  return window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`).matches;
};

/**
 * 判断是否为移动端设备（含平板触屏场景）
 */
export const isMobileDevice = (): boolean => {
  const coarsePointer = window.matchMedia('(pointer: coarse)').matches;
  const noHover = window.matchMedia('(hover: none)').matches;
  const mobileUA = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

  return mobileUA || (coarsePointer && noHover);
};

/**
 * 判断是否应启用移动端体验
 * 优先保证移动设备在异常 viewport 下仍使用移动端布局
 */
export const isMobileExperience = (): boolean => {
  return isMobileViewport() || isMobileDevice();
};

/**
 * 判断当前视口是否为竖屏
 */
export const isPortraitViewport = (): boolean => {
  return window.matchMedia('(orientation: portrait)').matches;
};

/**
 * 应用全局设备类型 class（用于样式兜底）
 */
export const applyDeviceClass = (): void => {
  const html = document.documentElement;
  const mobile = isMobileExperience();
  const portrait = isPortraitViewport();

  html.classList.toggle('device-mobile', mobile);
  html.classList.toggle('device-desktop', !mobile);
  html.classList.toggle('device-portrait', portrait);
};
